'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools.js');

var _formatDuration = require('helpers/formatDuration');

var _formatDuration2 = _interopRequireDefault(_formatDuration);

var _basketHelpers = require('helpers/basketHelpers');

var _JourneyHeader = require('./JourneyHeader.jsx');

var _JourneyHeader2 = _interopRequireDefault(_JourneyHeader);

var _Segments = require('./Segments.jsx');

var _Segments2 = _interopRequireDefault(_Segments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Journey(props) {
  var journey = props.journey,
      duration = props.duration;

  var codeOrigin = (0, _basketHelpers.getAirJourneyOrigin)(journey).cityName || (0, _basketHelpers.getAirJourneyOrigin)(journey).cityCode;
  var codeDest = (0, _basketHelpers.getAirJourneyDestination)(journey).cityName || (0, _basketHelpers.getAirJourneyDestination)(journey).cityCode;

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'Journey' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(_JourneyHeader2.default, {
            from: codeOrigin,
            to: codeDest,
            duration: (0, _formatDuration2.default)(duration)
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Segments2.default, { segments: (0, _basketHelpers.getAirJourneySegments)(journey) })
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(Journey);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Journey.jsx
// module id = 1479
// module chunks = 0